import { fromJS } from 'immutable';

const initialState = fromJS({
  masses: []
});

export default (state = initialState,
    action) => {
  switch (action.type) {
    case 'CLEAR_MASSES': {
      return state.set('masses', fromJS([]));
    }

    case 'ADD_MASSES': {
      const sortedMasses = fromJS(action.masses).sort((a, b) => {
        return new Date(a.get('date')) - new Date(b.get('date'));
      });
      return state.set('masses', sortedMasses);
    }

    case 'REMOVE_MASS': {
      const removableMass = state.get('masses').findIndex(mass => mass.get('id') === fromJS(action.mass));
      if (removableMass !== -1) {
        return state.set('masses', state.get('masses').delete(removableMass));
      }
      return state;
    }
  
    case 'ADD_MASS': {
     const newMass = fromJS(action.mass);
      if (state.get('masses').find(mass => mass.get('id') === newMass.get('id')) === undefined) {
        return state.set('masses', state.get('masses').push(newMass));
      }
      return state;
    }

    case 'CHANGE_MASS': {
      const changingIndex = state.get('masses').findIndex( mass => mass.get('id') === fromJS(action.mass.id));
      if (state.get('masses').get(changingIndex) === fromJS(action.mass)) {
        return state;
      }
      const newMasses = state.get('masses').set(changingIndex, fromJS(action.mass));
      return state.set('masses', newMasses);
    }

    default: {
      return state;
    }
  }
};